import toast from "../../../template/layout/utility/sa-toast";
import UtilityMixin from "../../utility/UtilityMixin";

/**
 * Chiamate REST verso il modulo backend AnDIamo (integrazione ADI - Regione
 * Campania). Segue lo stesso schema di SiatMixin: un metodo "azione" che fa
 * la chiamata, un metodo "...Success" e uno "...Error" per ciascuna.
 *
 * Copre solo gli scenari di competenza HCP (non l'inserimento segnalazione,
 * che spetta a COT/MMG - vedi la specifica v2.2, tabella "attore").
 */
export default {
    inject: ["openShowModalLoading", "closeShowModalLoading"],
    mixins: [UtilityMixin],
    data() {
        return {
            andiamoPaiPathResource: "/andiamo/pai",
            andiamoPaiLocaliPathResource: "/andiamo/pai/locali",
            andiamoPaiRiepilogoPathResource: "/andiamo/pai/riepilogo",
            andiamoErogazioniPathResource: "/andiamo/erogazioni",
            andiamoErogazioniLocaliPathResource: "/andiamo/erogazioni/locali",
            // Accessi PIANIFICATI letti da AnDIamo (gesan_andiamo_accessi_letti),
            // DISTINTI dalle erogazioni che inviamo noi sopra. Prima non
            // esisteva: la lista Accessi leggeva per errore da
            // andiamoErogazioniLocaliPathResource (sempre vuota).
            andiamoAccessiPathResource: "/andiamo/accessi/locali",
            // Prestazioni COLLEGATE agli accessi (gesan_andiamo_accessi_prestazioni):
            // fonte corretta per "quali prestazioni ha questo accesso", non
            // derivata da un join con pai_attivita (concetto diverso: quello e'
            // la programmazione/frequenza dal CarePlan).
            andiamoAccessiPrestazioniPathResource: "/andiamo/accessi/prestazioni",
            andiamoUtentiPathResource: "/andiamo/utenti",
            andiamoUtentiLocaliPathResource: "/andiamo/utenti/locali",

            andiamoUtentiItems: [],
            andiamoUtentiRowsNumber: 0,

            andiamoPaiItems: [],
            andiamoPaiRowsNumber: 0,
            andiamoAccessiItems: [],
            andiamoAccessiRowsNumber: 0,
            andiamoErogazioniItems: [],

            andiamoEventoSelezionato: null,
        };
    },
    methods: {
        // ------------------------------------------------------------------
        // Recupero lista PAI assegnati (sincronizza da AnDIamo) + lista locale
        // ------------------------------------------------------------------
        andiamoSincronizzaListaPai(codiceAsl, soloNonLetti = true) {
            this.openShowModalLoading();
            let link = process.env.VUE_APP_PATH_API + this.andiamoPaiPathResource;
            UtilityMixin.methods.restCallGet(link, { codiceAsl: codiceAsl, soloNonLetti: soloNonLetti }, this.andiamoSincronizzaListaPaiSuccess, this.andiamoSincronizzaListaPaiError);
        },
        andiamoSincronizzaListaPaiSuccess(response) {
            this.closeShowModalLoading();
            toast.success("Lista PAI aggiornata da AnDIamo (" + (response.data.data ? response.data.data.length : 0) + " eventi non letti)");
            this.andiamoCaricaListaPaiLocale();
        },
        andiamoSincronizzaListaPaiError(error) {
            this.closeShowModalLoading();
            toast.error("Errore nel Recupero lista PAI assegnati: " + (error?.response?.data?.messaggio || error.message));
        },
        andiamoCaricaListaPaiLocale(filtro = {}) {
            // this.openShowModalLoading();
            UtilityMixin.methods.loadDataResources(this.andiamoPaiLocaliPathResource, filtro, this.andiamoCaricaListaPaiLocaleSuccess, this.andiamoCaricaListaPaiLocaleError);
        },
        andiamoCaricaListaPaiLocaleSuccess(response) {
            this.andiamoPaiItems = response.data.data.list ? response.data.data.list : [];
            this.andiamoPaiRowsNumber = response.data.data.recordsNumber ? response.data.data.recordsNumber : this.andiamoPaiItems.length;
            // this.closeShowModalLoading();
        },
        andiamoCaricaListaPaiLocaleError(error) {
            // this.closeShowModalLoading();
            toast.error("Errore nel caricamento della lista PAI locale: " + (error?.response?.data?.messaggio || error.message));
        },

        // ------------------------------------------------------------------
        // Lista PAI "riepilogo": una riga per idPai, mai duplicata
        // ------------------------------------------------------------------
        andiamoCaricaListaPaiRiepilogo(filtro = {}) {
            this.openShowModalLoading();
            UtilityMixin.methods.loadDataResources(this.andiamoPaiRiepilogoPathResource, filtro, this.andiamoCaricaListaPaiRiepilogoSuccess, this.andiamoCaricaListaPaiLocaleError);
        },
        andiamoCaricaListaPaiRiepilogoSuccess(response) {
            this.andiamoPaiItems = response.data.data.list ? response.data.data.list : [];
            this.andiamoPaiRowsNumber = response.data.data.recordsNumber ? response.data.data.recordsNumber : this.andiamoPaiItems.length;
            this.closeShowModalLoading();
        },

        // ------------------------------------------------------------------
        // Notifica presa in carico evento PAI
        // ------------------------------------------------------------------
        andiamoConfermaPresaInCarico(evento, codiceAsl, callbackSuccess = null) {
            this.andiamoEventoSelezionato = evento;
            // this.openShowModalLùoading();
            let link = this.andiamoPaiPathResource + "/" + evento.idPai + "/presa-in-carico/" + evento.idEvento;
            UtilityMixin.methods.putResource(link + "?codiceAsl=" + encodeURIComponent(codiceAsl), {}, callbackSuccess || this.andiamoConfermaPresaInCaricoSuccess, this.andiamoConfermaPresaInCaricoError);
        },
        andiamoConfermaPresaInCaricoSuccess(response) {
            response;
            // this.closeShowModalLoading();
            toast.success("Presa in carico confermata");
        },
        andiamoConfermaPresaInCaricoError(error) {
            // this.closeShowModalLoading();
            toast.error("Errore in Notifica presa in carico: " + (error?.response?.data?.messaggio || error.message));
        },

        // ------------------------------------------------------------------
        // Recupero dettaglio PAI (sincronizza da AnDIamo) + dettaglio locale
        // ------------------------------------------------------------------
        andiamoSincronizzaDettaglioPai(idPai, codiceAsl, tuttiIPei = false, callbackSuccess = null) {
            // this.openShowModalLoading();
            let link = process.env.VUE_APP_PATH_API + this.andiamoPaiPathResource + "/" + idPai;
            UtilityMixin.methods.restCallGet(link, { codiceAsl: codiceAsl, tuttiIPei: tuttiIPei }, callbackSuccess || this.andiamoSincronizzaDettaglioPaiSuccess, this.andiamoSincronizzaDettaglioPaiError);
        },
        andiamoSincronizzaDettaglioPaiSuccess(response) {
            response;
            // this.closeShowModalLoading();
            toast.success("Dettaglio PAI aggiornato da AnDIamo");
        },
        andiamoSincronizzaDettaglioPaiError(error) {
            // this.closeShowModalLoading();
            toast.error("Errore nel Recupero dettaglio PAI: " + (error?.response?.data?.messaggio || error.message));
        },
        andiamoCaricaDettaglioPaiLocale(idPai, callbackSuccess, callbackError = null) {
            // this.openShowModalLoading();
            let link = process.env.VUE_APP_PATH_API + this.andiamoPaiPathResource + "/" + idPai + "/locale";
            UtilityMixin.methods.restCallGet(link, {}, callbackSuccess, callbackError || this.andiamoCaricaDettaglioPaiLocaleError);
        },
        andiamoCaricaDettaglioPaiLocaleError(error) {
            // this.closeShowModalLoading();
            if (error?.response?.status === 404) {
                toast.error("Nessun dettaglio locale per questo PAI: aggiornalo prima da AnDIamo");
            } else {
                toast.error("Errore nel caricamento del dettaglio PAI locale: " + (error?.response?.data?.messaggio || error.message));
            }
        },

        // ------------------------------------------------------------------
        // Recupero accessi pianificati/erogati (sincronizza da AnDIamo) + locali
        // ------------------------------------------------------------------
        andiamoSincronizzaAccessi(filtro) {
            // this.openShowModalLoading();
            let link = process.env.VUE_APP_PATH_API + this.andiamoErogazioniPathResource;
            UtilityMixin.methods.restCallGet(link, filtro, this.andiamoSincronizzaAccessiSuccess, this.andiamoSincronizzaAccessiError);
        },
        andiamoSincronizzaAccessiSuccess(response) {response;
            // this.closeShowModalLoading();
            toast.success("Accessi aggiornati da AnDIamo");
            this.andiamoCaricaAccessiLocali();
        },
        andiamoSincronizzaAccessiError(error) {
            // this.closeShowModalLoading();
            toast.error("Errore nel Recupero accessi pianificati/erogati: " + (error?.response?.data?.messaggio || error.message));
        },
        andiamoCaricaAccessiLocali(filtro = {}) {
            // this.openShowModalLoading();
            UtilityMixin.methods.loadDataResources(this.andiamoErogazioniLocaliPathResource, filtro, this.andiamoCaricaAccessiLocaliSuccess, this.andiamoCaricaAccessiLocaliError);
        },
        andiamoCaricaAccessiLocaliSuccess(response) {
            this.andiamoAccessiItems = response.data.data.list ? response.data.data.list : [];
            this.andiamoAccessiRowsNumber = response.data.data.recordsNumber ? response.data.data.recordsNumber : this.andiamoAccessiItems.length;
            // this.closeShowModalLoading();
        },
        andiamoCaricaAccessiLocaliError(error) {
            // this.closeShowModalLoading();
            toast.error("Errore nel caricamento degli accessi locali: " + (error?.response?.data?.messaggio || error.message));
        },
        /**
         * Accessi PIANIFICATI letti da AnDIamo (gesan_andiamo_accessi_letti),
         * con il loro vero codice_accesso AnDIamo - da usare per l'erogazione
         * al posto di inventare un codice_accesso lato nostro.
         */
        andiamoCaricaAccessiPianificatiLocali(filtro = {}, callbackSuccess = null) {
            this.openShowModalLoading();
            UtilityMixin.methods.loadDataResources(this.andiamoAccessiPathResource, filtro, callbackSuccess || this.andiamoCaricaAccessiLocaliSuccess, this.andiamoCaricaAccessiLocaliError);
        },
        /**
         * Prestazioni gia' erogate per un PAI (usato nella view del PAI per
         * capire quali prestazioni sono gia' state erogate). Endpoint
         * dedicato (non /locali): fa un JOIN lato server perche' idPai non
         * e' una colonna della tabella prestazioni, solo di quella padre.
         */
        andiamoCaricaPrestazioniErogatePerPai(idPai, callbackSuccess) {
            // this.openShowModalLoading();
            let link = process.env.VUE_APP_PATH_API + this.andiamoErogazioniPathResource + "/prestazioni-erogate";
            UtilityMixin.methods.restCallGet(link, { idPai: idPai }, callbackSuccess, this.andiamoCaricaAccessiLocaliError);
        },

        // ------------------------------------------------------------------
        // Erogazione (registra una prestazione come eseguita)
        // ------------------------------------------------------------------
        andiamoInviaErogazione(body, callbackSuccess = null, callbackError = null) {
            // this.openShowModalLoading();
            let link = process.env.VUE_APP_PATH_API + this.andiamoErogazioniPathResource;
            UtilityMixin.methods.restCallPost(link, body, callbackSuccess || this.andiamoInviaErogazioneSuccess, callbackError || this.andiamoInviaErogazioneError);
        },
        andiamoInviaErogazioneSuccess(response) {
            // this.closeShowModalLoading();
            if (response.data.data && response.data.data.stato === "RIFIUTATA") {
                toast.error("Erogazione RIFIUTATA da AnDIamo: " + (response.data.data.messaggioEsito || ""));
            } else {
                toast.success("Erogazione registrata con successo");
            }
        },
        andiamoInviaErogazioneError(error) {
            // this.closeShowModalLoading();
            toast.error("Errore nell'invio dell'erogazione: " + (error?.response?.data?.messaggio || error.message));
        },

        // ------------------------------------------------------------------
        // Utenti/operatori HCP (Inserimento/Modifica/Cancellazione/Recupero)
        // ------------------------------------------------------------------
        /**
         * Crea nel gestionale (modulo security) l'utenza dell'operatore: profilo =
         * ruolo AnDIamo, scadenza oggi + 3 mesi, password generata dal backend e
         * inviata per email (non compare mai nella risposta).
         */
        andiamoCreaUtenzaGestionale(codiceFiscaleOperatore, username, callbackSuccess = null, callbackError = null) {
            let link = process.env.VUE_APP_PATH_API + this.andiamoUtentiPathResource + "/" + codiceFiscaleOperatore + "/crea-utenza";
            UtilityMixin.methods.restCallPost(link, { username: username }, callbackSuccess, callbackError);
        },
        andiamoInserisciUtente(body, callbackSuccess = null, callbackError = null) {
            // this.openShowModalLoading();
            let link = process.env.VUE_APP_PATH_API + this.andiamoUtentiPathResource;
            UtilityMixin.methods.restCallPost(link, body, callbackSuccess || this.andiamoUtenteSuccess, callbackError || this.andiamoUtenteError);
        },
        andiamoModificaUtente(codiceFiscaleOperatore, body, callbackSuccess = null, callbackError = null) {
            // this.openShowModalLoading();
            UtilityMixin.methods.putResource(this.andiamoUtentiPathResource + "/" + codiceFiscaleOperatore, body, callbackSuccess || this.andiamoUtenteSuccess, callbackError || this.andiamoUtenteError);
        },
        andiamoDisattivaUtente(codiceFiscaleOperatore, codiceHcp, dataFine, callbackSuccess = null) {
            // this.openShowModalLoading();
            let link = process.env.VUE_APP_PATH_API + this.andiamoUtentiPathResource + "/" + codiceFiscaleOperatore;
            let query = "?codiceHcp=" + encodeURIComponent(codiceHcp || "");
            if (dataFine) {
                query += "&dataFine=" + encodeURIComponent(dataFine);
            }
            UtilityMixin.methods.restCallDelete(link + query, callbackSuccess || this.andiamoUtenteSuccess, this.andiamoUtenteError);
        },
        andiamoUtenteSuccess(response) {
            // this.closeShowModalLoading();
            toast.success(response.data.data && response.data.data.messaggioEsito ? response.data.data.messaggioEsito : "Operazione registrata con successo");
        },
        andiamoUtenteError(error) {
            // this.closeShowModalLoading();
            toast.error("Errore nella comunicazione con AnDIamo: " + (error?.response?.data?.messaggio || error.message));
        },
        andiamoSincronizzaUtentiAttivi(codiceHcp) {
            // this.openShowModalLoading();
            let link = process.env.VUE_APP_PATH_API + this.andiamoUtentiPathResource;
            UtilityMixin.methods.restCallGet(link, { codiceHcp: codiceHcp }, this.andiamoSincronizzaUtentiAttiviSuccess, this.andiamoUtenteError);
        },
        andiamoSincronizzaUtentiAttiviSuccess(response) {response;
            // this.closeShowModalLoading();
            toast.success("Utenti attivi aggiornati da AnDIamo");
            this.andiamoCaricaUtentiLocali();
        },
        andiamoCaricaUtentiLocali(filtro = {}) {
            // this.openShowModalLoading();
            UtilityMixin.methods.loadDataResources(this.andiamoUtentiLocaliPathResource, filtro, this.andiamoCaricaUtentiLocaliSuccess, this.andiamoUtenteError);
        },
        andiamoCaricaUtentiLocaliSuccess(response) {
            this.andiamoUtentiItems = response.data.data.list ? response.data.data.list : [];
            this.andiamoUtentiRowsNumber = response.data.data.recordsNumber ? response.data.data.recordsNumber : this.andiamoUtentiItems.length;
            this.closeShowModalLoading();
        },
        andiamoCaricaDettaglioUtenteLocale(codiceFiscaleOperatore, callbackSuccess, callbackError = null) {
            // this.openShowModalLoading();
            let link = process.env.VUE_APP_PATH_API + this.andiamoUtentiLocaliPathResource;
            UtilityMixin.methods.restCallGet(link, { codiceFiscaleOperatore: codiceFiscaleOperatore }, callbackSuccess, callbackError || this.andiamoUtenteError);
        },
        andiamoSincronizzaDettaglioUtente(codiceFiscaleOperatore, codiceHcp, callbackSuccess = null) {
            // this.openShowModalLoading();
            let link = process.env.VUE_APP_PATH_API + this.andiamoUtentiPathResource + "/" + codiceFiscaleOperatore;
            UtilityMixin.methods.restCallGet(link, { codiceHcp: codiceHcp }, callbackSuccess || this.andiamoUtenteSuccess, this.andiamoUtenteError);
        },
        /**
         * Frequenza in italiano leggibile, invece del crudo "1 volta/e ogni
         * 1 wk". Gestisce le unita' UCUM piu' comuni in questo dominio
         * clinico (s/min/h/d/wk/mo/a) e la pluralizzazione semplice
         * (1 volta/settimana vs 2 volte/settimane, periodo=1 omesso).
         */
        formatFrequenza(frequenza, periodo, periodUnit) {
            if (!frequenza && frequenza !== 0) {
                return "-";
            }
            let unitaSingolare = { s: "secondo", min: "minuto", h: "ora", d: "giorno", wk: "settimana", mo: "mese", a: "anno" };
            let unitaPlurale = { s: "secondi", min: "minuti", h: "ore", d: "giorni", wk: "settimane", mo: "mesi", a: "anni" };
            let unita = (Number(periodo) > 1 ? unitaPlurale[periodUnit] : unitaSingolare[periodUnit]) || periodUnit;
            let voltaLabel = Number(frequenza) === 1 ? "volta" : "volte";
            if (!periodo || Number(periodo) === 1) {
                return frequenza + " " + voltaLabel + " a " + unita;
            }
            return frequenza + " " + voltaLabel + " ogni " + periodo + " " + unita;
        },
        /**
         * Nome del ruolo invece del solo codice numerico, stesso CodeSystem
         * tipoOperatore gia' usato per le select del modulo utenti/erogazioni.
         */
        formatFiguraProfessionale(code) {
            let nomi = {
                1: "MMG",
                2: "PLS",
                3: "Infermiere",
                4: "Medico specialista",
                5: "Medico esperto in cure palliative",
                6: "Continuità assistenziale",
                7: "Psicologo",
                8: "Fisioterapista",
                9: "Logopedista",
                10: "OSS",
                11: "Dietista",
                12: "Assistente sociale del SSN",
                13: "Terapista occupazionale",
                99: "Altro",
            };
            if (!code) {
                return "-";
            }
            return nomi[code] ? code + " - " + nomi[code] : code;
        },
    },
};